
import {FETCH_CUSTOMER_EMAIL} from "../actionTypes";
import { fetchCustomerEmail } from "../../../api/userManagement/getCustomerEmail.service";


const requestListRequest = ()=>({type: FETCH_CUSTOMER_EMAIL.REQUEST})
const requestListFailure = (error)=>({type: FETCH_CUSTOMER_EMAIL.FAILURE, error})
const requestListSuccess = (obj)=>({type: FETCH_CUSTOMER_EMAIL.SUCCESS, obj})

export const getCustomerEmail = (email)=>{
    return (dispatch, getState)=>{        
        dispatch(requestListRequest()) 
        return fetchCustomerEmail(email)  
        .then((res) => {
            dispatch(requestListSuccess(res));
            return Promise.resolve(true)
          })
        .catch(error => {
            dispatch(requestListFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}